import React from 'react';
import { AcvtSupportedLanguages } from '../../../types/acvt';
import { PreviewSectionHeader, useT } from '../../preview';
import style from './style.module.scss';

type AcvtHomeGamesProps = {
    /**
     * Kept for backward compatibility — strings come from `useT()`.
     */
    language?: AcvtSupportedLanguages;
    smallCards: React.ReactNode;
    featuredCards?: React.ReactNode;
};

/**
 * Home page games section. Renders a "bento" grid where featured
 * (large, horizontal) game cards span the whole row and the small
 * (vertical) cards sit in a 2-column grid below them.
 */
export const AcvtHomeGames = ({
    smallCards,
    featuredCards,
}: AcvtHomeGamesProps) => {
    const t = useT();

    // Filter out null/falsy children so we don't render empty bento
    // cells when the caller maps over an array with sparse entries.
    const featuredItems = React.Children.toArray(featuredCards).filter(Boolean);
    const smallItems = React.Children.toArray(smallCards).filter(Boolean);

    return (
        <section className={style.content}>
            <PreviewSectionHeader title={t.games.header} />
            <div className={style.bento}>
                {featuredItems.map((card, index) => (
                    <div key={`f-${index}`} className={style.bento_full}>
                        {card}
                    </div>
                ))}
                {smallItems.map((card, index) => (
                    <div key={`s-${index}`} className={style.bento_half}>
                        {card}
                    </div>
                ))}
            </div>
        </section>
    );
};
